export interface AclGroup {
  aclGroupId: number;
  name: string;
  description: string;
  permissions: AclGroupPermission[];
  users: UserAclGroup[];
}

export interface AclGroupPermission {
  aclGroupPermissionId: number;
  permission: AclPermission;
  aclGroupId: number;
}

export interface UserAclGroup {
  userAclGroupId: number;
  userId: number;
  aclGroupId: number;
}

/**
 * Lato WS è una enumerazione. La descrizione è definita tramite attributo Display
 */
export interface AclPermissionDescription {
  id: AclPermission;
  description: string;
  category: string;
}

export enum AclPermission {
  GenerateTokens = 1,
  AclManagement = 2,
  SwitchUser = 4,
  QueueList = 5,

  AdminUsers = 100,

  UserLogged = 1000,
  TwoFactorsAuthentication = 1001,
  SkipTwoFactorsAuthentication = 1002,
  UserActivated = 1003,
}
